<template>
  <!-- 切换tab -->
  <div
    class="tab-nav"
  >
    <div
      ref="tabNav"
      class="nav-wrap"
    >
      <ul
        ref="navBar"
        class="nav-bar clearfix"
      >
        <template v-for="(item) in tabData">
          <li
            v-show="item.show"
            :key="item.fieldkey"
            v-anchor="{ anchorId: isAnchor ? item.fieldkey : '', top: -20 }"
            :class="{'active': item.fieldkey === currSelected}"
            @click="onTab(item.fieldkey)"
          >
            {{ item.fieldname }}
          </li>
        </template>
      </ul>
      <slot />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { anchor } from '@/lib/directives'
export default {
  directives: { anchor },
  props: {
    data: {
      type: Array,
      default: () => ({})
    },
    selected: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isAnchor: false,
      tabData: this.data,
      currSelected: this.selected
    }
  },
  watch: {
    selected (val) {
      this.currSelected = val
    }
  },
  methods: {
    onTab (value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped lang="scss">
.tab-nav {
  position: relative;
  height: 48px;
  z-index: 990;
  .nav-hidden {
    overflow: hidden;
  }
  .nav-wrap {
    position: absolute;
    width: 100%;
    height: 48px;
    background-color: #fff;
    overflow: hidden;
  }
  .nav-bar {
    position: relative;
    top: 1px;
    z-index: 2;
    height: 48px;
    li {
      position: relative;
      float: left;
      margin-right: 24px;
      height: 47px;
      line-height: 47px;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      &.active {
        color: $primary-color;
        border-bottom: solid 2px $primary-color;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
